<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">ID</div>
        <el-input v-model="detail.adid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">广告名</div>
        <el-input v-model="detail.title" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <!--
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">icon</div>
        <div class="headimg-container relative" style="width:250px">
          <uploadHeadImage :url.sync="detail.icon" :itype="5"></uploadHeadImage>
        </div>
      </div>
      -->
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">备注</div>
        <el-input type="textarea" :rows="2"  v-model="detail.remark" placeholder="仅后台使用" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">负责人</div>
        <el-select class="filter__input" size="mini" v-model="detail.opid">
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">上家</div>
        <el-select class="filter__input" size="mini" v-model="detail.arid" filterable>
          <el-option :label="item.name" :value="item.arid" v-for="(item, index) in aderLists" :key="index"></el-option>
        </el-select>
        <div class="dataForm__item ml-10">
          <el-button size="mini" @click="aderDialog = !aderDialog">添加上家</el-button>
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">对接第三方</div>
        <chnDockingSelect v-model="detail.cdid" :need-edit="true" />
      </div>
      <div class="dataForm__item mt-16" v-if="detail.cdid">
        <div class="dataForm__name">第三方报单链接</div>
        <el-input v-model="detail.docking_url" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">下单链接</div>
        <el-input v-model="detail.link" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">发票抬头</div>
        <invoiceTitleSelect v-model="detail.itid" :need-edit="true" />
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">上家折扣</div>
        <el-input v-model="detail.aver_discount" placeholder="上家给的折扣" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">底价折扣</div>
        <el-input v-model="detail.min_discount" placeholder="税后实际折扣" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">对公折扣</div>
        <el-input v-model="detail.corp_discount" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">用户折扣</div>
        <el-input v-model="detail.discount" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">投放时间</div>
        <el-date-picker v-model="dateTime" type="datetimerange" placeholder="选择时间范围" align="right" size="mini" class="date">
        </el-date-picker>
        <div class="dataForm__item ml-10" v-if="detail.budget.length === 0">
          <el-button size="mini" @click="budgetDialog = !budgetDialog">显示预算</el-button>
        </div>
      </div>
      <div class="dataForm__item mt-16" v-if="detail.budget.length || budgetDialog">
        <div class="dataForm__name">投放预算</div>
        <BudgetTable :lists.sync="detail.budget" />
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">限额方式</div>
        <el-radio-group v-model="detail.mode">
          <div class="dib mr-20">
            <el-radio :label="0">按照金额</el-radio>
            <el-radio :label="1">按照单数</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">总额度</div>
        <el-input v-model="detail.quota" placeholder="" size="mini" class="dataForm__input">
          <template slot="append" v-if="detail.mode === 0">￥</template>
          <template slot="append" v-if="detail.mode === 1">单</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">每日额度</div>
        <el-input v-model="detail.tquota" placeholder="" size="mini" class="dataForm__input">
          <template slot="append" v-if="detail.mode === 0">￥</template>
          <template slot="append" v-if="detail.mode === 1">单</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">拍手费</div>
        <el-input v-model="detail.agency_fees" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">完成截图提交时间</div>
        <el-input v-model="detail.apply_time" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">天后</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">订单有效时间</div>
        <el-input v-model="detail.effective_time" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">天</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">返现周期</div>
        <el-input v-model="detail.cashback_cycle" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否需要备注信息</div>
        <el-radio-group v-model="detail.extra">
          <div class="dib mr-20">
            <el-radio :label="0">不需要</el-radio>
            <el-radio :label="1">需要</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否需要填快递号</div>
        <el-radio-group v-model="detail.express">
          <div class="dib mr-20">
            <el-radio :label="0">不需要</el-radio>
            <el-radio :label="1">需要</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">完成条件</div>
        <el-radio-group v-model="detail.condition">
          <div class="dib mr-20">
            <el-radio :label="0">默认</el-radio>
            <el-radio :label="1">不需要完成截图</el-radio>
            <el-radio :label="2">不需要报单截图</el-radio>
            <el-radio :label="3">不需要截图</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">AI审核报单</div>
        <el-radio-group v-model="detail.ai_auto">
          <div class="dib mr-20">
            <el-radio :label="0">不自动通过</el-radio>
            <el-radio :label="1">自动通过</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否需要预售</div>
        <el-radio-group v-model="detail.presale">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否展示在首页</div>
        <el-radio-group v-model="detail.home">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否显示额度</div>
        <el-radio-group v-model="detail.is_quota">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>
      <!--
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">格式</div>
        <el-input v-model="detail.format" placeholder="" size="mini" class="dataForm__input"></el-input>
        <div class="ml-20" style="color: red">以逗号分割。如果存在一下名词，最好使用以下名词：订单号, 实付金, 日期, 收件人, 代理名, 手机号, 地址, 其中订单号, 实付金必填</div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">案例</div>
        <el-input v-model="detail.case" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      -->
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">状态</div>
        <el-radio-group v-model="detail.status">
          <div class="dib mr-20">
            <el-radio :label="item.value" v-for="(item, index) in statusList" :key="index">{{item.name}}</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">活动说明</div>
        <textarea id="editor"></textarea>
        <input type="file" @change="articleImgUpload" id="imgData" style="display: none">
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="adEdit">保存</button>
      </div>
    </div>
    <el-dialog title="上家编辑" :visible.sync="aderDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">上家ID</div>
            <el-input v-model="aderInfo.arid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">上家名</div>
            <el-input v-model="aderInfo.name" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="aderEdit">保存</div>
          <div class="gray-large-btn" @click="aderDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import util from '../../../script/util'
import {uploadImage, adDetail, adEdit, operLists, aderLists, aderEdit} from '../../../api/api'
import chnDockingSelect from '../../../components/data-select/chnDockingSelect.vue'
import BudgetTable from '../../../components/budget-table.vue'
import invoiceTitleSelect from '../../../components/data-select/invoiceTitleSelect.vue'
export default {
  name: 'adEdit',
  components: {
    chnDockingSelect,
    BudgetTable,
    invoiceTitleSelect
  },
  data () {
    return {
      detail: {
        adid: 0,
        title: '',
        cover: '',
        icon: '',
        opid: '',
        arid: '',
        cdid: '',
        itid: '',
        docking_url: '',
        aver_discount: '',
        min_discount: '',
        corp_discount: '',
        discount: '',
        home: 1,
        is_quota: 1,
        mode: 0,
        quota: '',
        tquota: '',
        agency_fees: 0,
        apply_time: 7,
        effective_time: 90,
        extra: 0,
        express: 0,
        condition: 0,
        ai_auto: 0,
        presale: 0,
        cashback_cycle: '',
        link: '',
        format: '微信昵称,订单号,实付金',
        case: '小贝,00000000,200',
        end_time: '',
        start_time: '',
        remark: '',
        budget: [],
        status: 1
      },
      dialog: false,
      budgetDialog: false,
      aderDialog: false,
      aderInfo: {
        arid: 0,
        name: ''
      },
      dateTime: '',
      operLists: [],
      aderLists: [],
      statusList: [
        {
          name: '正常',
          value: 1
        },
        {
          name: '停止',
          value: 0
        },
        {
          name: '完结',
          value: 2
        }
      ]
    }
  },
  methods: {
    dateTimeChange () {
      if (this.dateTime) {
        this.detail.start_time = parseInt(new Date(this.dateTime[0]).getTime() / 1000)
        this.detail.end_time = parseInt(new Date(this.dateTime[1]).getTime() / 1000)
      } else {
        this.detail.start_time = ''
        this.detail.end_time = ''
      }
    },
    initEditor () { // 初始化编辑器
      window.CKEDITOR.replace('editor')
      this.initEvent()
    },
    initEvent () { // 声明全局事件
      let that = this
      window.showUpload = function () {
        document.querySelector('#imgData').click()
      }
      window.changeSrc = function (arr) {
        console.log(arr)
        let content = that.getContent()
        arr.forEach((item, index) => {
          while (content.indexOf(item.str) > -1) {
            content = content.replace(item.str, item.url)
          }
        })
        that.setContent(content)
      }
    },
    articleImgUpload (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return false
      let file = files[0]
      let imagefile = file.type
      let reader = new FileReader()
      let match = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif']
      let base64 = ''
      // 判断文件类型
      if (!((imagefile === match[0]) || (imagefile === match[1]) || (imagefile === match[2]) || (imagefile === match[3]))) {
        alert('请选择正确的图片类型')
        return
      }
      reader.readAsDataURL(file)
      e.target.value = '' // 清空input内图片
      reader.onload = (e) => {
        base64 = e.target.result
        uploadImage({
          icon: base64,
          itype: 4
        }).then(res => {
          let data = res.data || {c: -1}
          if (!data.c) {
            window.CKEDITOR.instances.editor.insertHtml('<img src="' + data.d.url + '">')
          }
        })
      }
    },
    getOperLists () {
      let params = {
        market: 3,
        status: 1,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.map((item, index) => {
            if ([4, 5, 16].includes(item['opid'])) {
              this.operLists.push(
                {
                  nickname: item.nickname,
                  opid: item.opid
                }
              )
            }
          })
        }
      })
    },
    getAderLists () {
      let params = {
        l: 500,
        p: 1
      }
      aderLists(params).then((res) => {
        let data = res.data || {c: -1}

        if (!data.c) {
          this.aderLists = data.d.lists.map((item, index) => {
            return {
              name: item.name,
              arid: item.arid
            }
          })
        }
      })
    },
    // 公众号详情
    adDetail () {
      let params = {
        adid: this.detail.adid
      }
      this.loading = true
      adDetail(params).then((res) => {
        let data = res.data || {c: -1}
        console.log(data)
        if (!data.c) {
          this.dateTime = [data.d.start_time * 1000, data.d.end_time * 1000]
          this.detail = data.d

          this.setContent(data.d.desc)
          let count = 0
          let clear = setInterval(() => {
            this.setContent(data.d.desc)
            count++
            if (count >= 2) {
              clearInterval(clear)
            }
          }, 1000)
        }
        this.loading = false
      })
    },
    aderEdit () {
      let params = {
        arid: this.aderInfo.arid,
        name: this.aderInfo.name
      }

      aderEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.aderDialog = false
          this.getAderLists()

          for (let key in this.aderInfo) {
            this.aderInfo[key] = ''
          }
          this.aderInfo.arid = 0
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    adEdit () {
      let params = util.cloneObj(this.detail)
      params.format = params.format.replace(/^,+/, '').replace(/,+$/, '')
      params.format = params.format.replace(/^，+/, '').replace(/，+$/, '')
      params.format = params.format.replace(/(^\s*)|(\s*$)/g, '').replace(/，/g, ',').replace(/\n|\r/g, '')
      params.case = params.case.replace(/(^\s*)|(\s*$)/g, '').replace(/，/g, ',').replace(/\n|\r/g, '')
      params.desc = this.getContent()

      // 格式化
      params['budget'] = JSON.stringify({'lists': this.detail.budget})

      let content = ''

      if (params['opid'] === '') {
        content = '请选择负责人'
      }

      if (params['arid'] === '') {
        content = '请选择上家'
      }

      if (params['cdid'] === '') {
        params['cdid'] = 0
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/adList')
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
      })
    },
    getContent () { // 获取编辑器内容
      return window.CKEDITOR.instances['editor'].getData()
    },
    setContent (content) {
      window.CKEDITOR.instances['editor'].setData(content)
    },
    beforeunloadHandler (e) {
      if (!this.detail.adid) {
        util.setCookie('createAddetail', JSON.stringify(this.detail))
      }
    }
  },
  watch: {
    'dateTime': 'dateTimeChange'
  },
  destroyed () {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
  },
  mounted () {
    this.detail.adid = parseInt(this.$route.query.adid || 0)
    if (this.detail.adid) {
      this.adDetail()
    } else {
      let createAddetail = util.getCookie('createAddetail')
      if (createAddetail) {
        createAddetail = JSON.parse(createAddetail)
        this.detail = util.cloneObj(createAddetail)
      }
    }

    this.getOperLists()
    this.getAderLists()
    this.initEditor()
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adEdit.vue